export const menuItems = [
    { label: 'Dashboard', route: '/dashboard' },
    { label: 'Users', route: '/users' },
    { label: 'Properties', route: '/properties' },
    { label: 'Reservations', route: '/reservations' },
    { label: 'Reporting', href: '#' }, // TODO the real link needs to go here
    { label: 'Affiliate Management', href: '#' }, // TODO the real link needs to go here
];

export const ownerMenuItems = [
    { label: 'Dashboard', route: '/ownerDashboard' },
    { label: 'Property Report', route: '/propertyReport' },
];
